<template>
  <b-container class="section-b-space section-t-space">
    <div class="col-md-6 offset-md-3 text-center email-varification">
      <b-card>
        <h2>{{ _T('Email Verification') }}</h2>
        <h2 class="text-center" v-if="otp_progress">
          <svg width="50" height="35">
            <use xlink:href="#loading" />
          </svg>
          <h4 class="mb-0">{{ _T('Confirming Token...') }}</h4>
        </h2>
        <h2 v-else class="text-center">
          <div
            v-if="otp_confirmed"
            class="d-flex align-items-center justify-content-center success"
          >
            <svg width="50" height="35">
              <use xlink:href="#success_check" />
            </svg>
            <h4 class="mb-0">{{ _T('Email Verified.') }}</h4>
          </div>
          <div
            v-if="otp_progress_fail"
            class="d-flex align-items-center justify-content-center failed"
          >
            <svg width="50" height="35">
              <use xlink:href="#fail_message" />
            </svg>
            <h4 class="mb-0">{{ _T('Email Verification Failed.') }}</h4>
          </div>
        </h2>
      </b-card>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import * as CONST from '@/constants'

export default {
  data: () => {
    return {
      brand_id: null,
      email: null,
      token: null,
    }
  },
  name: 'EmailConfirmation',
  computed: {
    ...mapGetters([
      '_T',
      'otp_verification',
      'otp_progress',
      'otp_progress_fail',
      'otp_confirmed',
      'otp_progress_reference',
    ]),
  },
  mounted() {
    this.email = this.$route.params.email
    this.token = this.$route.params.token
    this.brand_id = this.$route.params.brand_id || null
    this.$store.commit('SET_OTP_IN_PROGRESS')
    this.$store.commit('SET_VERIFICATION_BRAND_ID', this.brand_id)
    this.$store.commit('SET_MODE_REFERENCE_DATA', {
      mode: CONST.OTP_VERIFICATION_FOR_EMAIL,
      reference: this.email,
    })
    this.confirmOTP()
  },
  methods: {
    confirmOTP() {
      var that = this
      this.$store.dispatch('confirmOTP', this.token).then(() => {
        if (that.otp_confirmed) {
          this.$store
                .dispatch('load_customer',true)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.email-varification {
	svg{
  width: $px25;
  margin-right: $px10;
  }
  .failed {
    color: $color-primary;
  }
}
</style>
